export const COMPLEMENTS_PLACEMENT_ID = 'monetization_complements_pdp';
export const SUGGESTIONS_PLACEMENT_ID = 'monetization_suggestions_pdp';
export const SUBSTITUTES_PLACEMENT_ID = 'monetization_substitutes_pdp';
